import { render } from "./ButtonComment.vue?vue&type=template&id=fbd755a8&scoped=true"
import script from "./ButtonComment.vue?vue&type=script&lang=js"
export * from "./ButtonComment.vue?vue&type=script&lang=js"

import "./ButtonComment.vue?vue&type=style&index=0&id=fbd755a8&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd755a8"]])

export default __exports__